import {createSelector} from '@reduxjs/toolkit'
import {humanReadableDate} from '../../app/utils'
import {currentAgentApplicationSelector} from './collectorApplicationSelector'

const licenceHistoryQuestionSelector = createSelector(
    [state => state.components,
        currentAgentApplicationSelector],
    (components, agentApplication) => {
        let licenceHistoryQuestion = components.licenceHistoryQuestion

        return Object.assign({},licenceHistoryQuestion, {
            collectorApplicantDetails : agentApplication?.businessLicenceData?.applicantDetails
        })
    }
)

export const licenceHistoryQuestionSelect = state => ({
    licenceHistoryQuestion: licenceHistoryQuestionSelector(state)
})

const licenceHistoryDetailsSelector = createSelector(
    [state => state.components,
        state => state.primaryAgencyApplication.application.businessLicenceData,
        currentAgentApplicationSelector],
    (components,appData,agentApplication) => {
        let licenceHistoryList = []

        if(appData && appData.licenceHistoryList)
            licenceHistoryList = appData.licenceHistoryList

        return Object.assign({},
            components.licenceHistoryDetails,
            {
                licenceHistoryList,
                collectorApplicantDetails : agentApplication?.businessLicenceData?.applicantDetails,
                collectorLicenceHistoryDetails : agentApplication?.businessLicenceData?.licenceHistoryDetails
            })
    }
)

export const licenceHistoryDetailsSelect = state => ({
    licenceHistoryDetails: licenceHistoryDetailsSelector(state)
})

export function populateLicenceHistoryListQuestionForReview(licenceElsewhere) {
    if(!licenceElsewhere || (Array.isArray(licenceElsewhere) && licenceElsewhere.length === 0)) {
        return {
            "Has your company held business licence from another province or territory?" : "No"
        }
    }

    return {
        "Has your company held business licence from another province or territory?" : "Yes",
    }
}

export function populateLicenceHistoryListDataForReview(licenceElsewhere) {
    let data = []

    if(licenceElsewhere) {
        licenceElsewhere.forEach((licence) => {
            data.push(
                {
                    "Type of business licence" : licence.businessLicenceType,
                    "Province" : licence.province,
                    "Start Date" : humanReadableDate(licence.startDate),
                    "End Date" : humanReadableDate(licence.endDate)
                }
            )
        } )
    }

    return data
}

const licenceSuspensionQuestionSelector = createSelector(
    [state => state.components,
    state => state.additionalApplications.additionalBranchApplications,
    currentAgentApplicationSelector],
    (components, additionalBranches, agentApplication) => {
        let licenceSuspensionQuestion = components.licenceSuspensionQuestion

        return Object.assign({},licenceSuspensionQuestion, {
            collectorApplication : agentApplication?.businessLicenceData,
            additionalBranches
        })
    }
)

export const licenceSuspensionQuestionSelect = state => ({
    licenceSuspensionQuestion: licenceSuspensionQuestionSelector(state)
})

const licenceSuspensionDetailsSelector = createSelector(
    [state => state.components, 
    state => state.primaryAgencyApplication.application?.businessLicenceData, 
    currentAgentApplicationSelector, 
    state => state.additionalApplications.additionalBranchApplications],
    (components, appData, agentApplication, additionalBranchApplication) => {
        let licenceSuspendedData = []

        if(appData) {
            if(appData.licenceSuspendedData)
                licenceSuspendedData = appData.licenceSuspendedData
        }

        return Object.assign({},
            components.licenceSuspensionDetails, 
            {   licenceSuspendedData,
                collectorApplicantDetails : agentApplication?.businessLicenceData?.applicantDetails,
                collectorLicenceSuspensionDetails : agentApplication?.businessLicenceData?.licenceSuspendedData,
                additionalBranches : additionalBranchApplication
            })
    }
)

export const licenceSuspensionDetailsSelect = state => ({
    licenceSuspensionDetails: licenceSuspensionDetailsSelector(state)
})

export function populateLicenceSuspensionQuestionForReview(licenceSuspension, isCollector) {
    const individualOrBusinessStr = isCollector ? "the individual" : "your company"
    const questionStr = `Has ${individualOrBusinessStr} had a business licence refused, suspended or revoked?`
    if(!licenceSuspension || 
        (Array.isArray(licenceSuspension) && licenceSuspension.length === 0)) {
        return {
            [questionStr] : "No"
        }
    }

    return {
        [questionStr] : "Yes",
    }
}

export function populateLicenceSuspensionDataForReview(licenceSuspension) {
    let data = []

    if(licenceSuspension) {
        licenceSuspension.forEach((suspension) => {
            data.push(
                {
                    "Type of business licence" : suspension.businessLicenceType,
                    "Province" : suspension.province,
                    "Suspension Date" : humanReadableDate(suspension.suspensionDate),
                    "Licence Action" : suspension.action ? suspension.action : "",
                    "Reason" : suspension.reason
                }
            )
        })
    }

    return data
}
